import { useQuery } from '@tanstack/react-query'

import { pedir } from './nucleo'

/**
 * Qué piezas del CMS dinámico están encendidas en esta instalación (plan §21 y §22 bis). Lo
 * decide el `.env` del núcleo (`apps/nucleo/src/config/interruptores.ts`) y lo dice
 * `GET /api/panel/interruptores`: el panel no lleva su copia. Apagada una pieza, el panel no la
 * enseña; el núcleo, además, responde 404 a lo suyo.
 */
export type Interruptores = {
  /** Tipos de contenido, taxonomías, términos, grupos de campos, plantillas y la IA de estructura. */
  estructura: boolean
  /** La biblioteca v2: lotes, documentos, SVG y privados. Apagada, se sube una imagen cada vez. */
  mediosV2: boolean
  /** «Vista previa» de un borrador. */
  previaContenido: boolean
  /** Google Maps con la clave de la plataforma. */
  mapasDePlataforma: boolean
}

/** Mientras no se sabe, todo apagado: no se enseña una puerta que quizá no abra. */
export const TODO_APAGADO: Interruptores = { estructura: false, mediosV2: false, previaContenido: false, mapasDePlataforma: false }

/** Para las pruebas y para quien no pasa los interruptores: lo de siempre, todo encendido. */
export const TODO_ENCENDIDO: Interruptores = { estructura: true, mediosV2: true, previaContenido: true, mapasDePlataforma: true }

export const useInterruptores = (): Interruptores => {
  const { data } = useQuery({ queryKey: ['interruptores'], queryFn: () => pedir<Interruptores>('/panel/interruptores'), staleTime: Infinity })
  return data ?? TODO_APAGADO
}
